import React from 'react';
import Icon from '../components/Icon';
import { useNavigate } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-code">404</h1>
        <h2>Ups! Tej strony nie ma</h2>
        <p>Wygląda na to, że ta strona zniknęła jak włosy po strzyżeniu...</p>
        <button className="notfound-home-btn" onClick={() => navigate('/')}>
          <Icon name="home" style={{marginRight:"7px"}} /> Wróć na stronę główną
        </button>
      </div>
    </div>
  );
};

export default NotFound;
